import { ScrollView, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import { SafeAreaView } from 'react-native-safe-area-context';
import { BookOpenCheck, Compass, Mountain, Sparkles } from 'lucide-react-native';
import { AppButton } from '../components/ui/AppButton';
import { AppCard } from '../components/ui/AppCard';
import { AppText } from '../components/ui/AppText';
import { tokens } from '../theme/tokens';

const onboardingCards = [
  {
    title: '看见自己的登峰路线',
    description: '首页会把薄弱点、计划和错题串起来，像一张学习登山图。',
    Icon: Mountain,
  },
  {
    title: '让峰峰陪你讲题',
    description: '问答、拍照搜题、试卷复盘都会先走本地 demo 交互。',
    Icon: Sparkles,
  },
  {
    title: '把错题变成下一步行动',
    description: '错题本、再练一次和成长计划会逐步连成闭环。',
    Icon: BookOpenCheck,
  },
];

export default function OnboardingPage() {
  const router = useRouter();

  return (
    <SafeAreaView style={styles.screen}>
      <ScrollView contentContainerStyle={styles.content}>
        <View style={styles.hero}>
          <View style={styles.heroIcon}>
            <Compass size={30} color={tokens.colors.white} />
          </View>
          <AppText variant="title" weight="bold" align="center">
            欢迎来到登峰
          </AppText>
          <AppText variant="body" tone="muted" align="center">
            先完成一个轻量引导，再选择当前年级。后续真实账号体系接入前，这里使用本地原型状态。
          </AppText>
        </View>

        <View style={styles.cardStack}>
          {onboardingCards.map(({ title, description, Icon }) => (
            <AppCard key={title} style={styles.infoCard}>
              <View style={styles.cardIcon}>
                <Icon size={20} color={tokens.colors.primary} />
              </View>
              <View style={styles.cardCopy}>
                <AppText variant="body" weight="bold">
                  {title}
                </AppText>
                <AppText variant="caption" tone="muted">
                  {description}
                </AppText>
              </View>
            </AppCard>
          ))}
        </View>

        <AppButton label="开始选择年级" onPress={() => router.replace('/grade-select')} />
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: tokens.colors.background,
  },
  content: {
    paddingHorizontal: tokens.layout.screenPadding,
    paddingTop: tokens.spacing.xxl,
    paddingBottom: tokens.spacing.xxl,
    gap: tokens.spacing.xl,
  },
  hero: {
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
  heroIcon: {
    width: 66,
    height: 66,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.primary,
  },
  cardStack: {
    gap: tokens.spacing.md,
  },
  infoCard: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
  cardIcon: {
    width: 42,
    height: 42,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  cardCopy: {
    flex: 1,
    gap: tokens.spacing.xs,
  },
});
